import { Box, Grid, Typography } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import React from "react";
import { DataPribadiResponse } from "../../../models/DataPribadi";
import {
  BaseGrid,
  IconTypography,
  SubTitleTypography,
  TitleTypography,
} from "../KandidatViewPage";

type Props = { data: DataPribadiResponse; foto: string };

export default function DataPribadiKandidatPage({ data, foto }: Props) {
  return (
    <BaseGrid container>
      <Grid
        container
        item
        xs={12}
        sx={{
          backgroundColor: "#00ACED",
          color: "#fff",
        }}
      >
        <TitleTypography>Data Pribadi</TitleTypography>
      </Grid>
      <Grid container item xs={6} direction="column">
        <Box
          component="img"
          src={`data:image/jpeg;base64,${foto}`}
          alt={`Profile-Image`}
          sx={{
            paddingTop: "8%",
            height: "auto",
            maxHeight: "25vh",
            maxWidth: "25vh",
            width: "50%",
          }}
        />
        <SubTitleTypography>Nama Lengkap</SubTitleTypography>
        <Typography>
          {data.NAMA_DEPAN} {data.NAMA_BELAKANG}
        </Typography>
        <SubTitleTypography>Tempat Tanggal Lahir</SubTitleTypography>
        <Typography>
          {data.TEMPAT_LAHIR}, {data.TANGGAL_LAHIR}
        </Typography>
        <SubTitleTypography>Agama</SubTitleTypography>
        <Typography>{data.AGAMA}</Typography>
        <SubTitleTypography>Jenis Kelamin</SubTitleTypography>
        <Typography>{data.JENIS_KELAMIN}</Typography>
        <SubTitleTypography>Tinggi</SubTitleTypography>
        <Typography>{data.TINGGI_BADAN} cm</Typography>
        <SubTitleTypography>Berat Badan</SubTitleTypography>
        <Typography>{data.BERAT_BADAN} kg</Typography>
        <SubTitleTypography>Golongan Darah</SubTitleTypography>
        <Typography>{data.GOLONGAN_DARAH}</Typography>
        <SubTitleTypography>Kebangsaan</SubTitleTypography>
        <Typography>{data.KEBANGSAAN}</Typography>
      </Grid>
      <Grid container item xs={6} direction="column">
        <SubTitleTypography>Kendaraan (Pemilik)</SubTitleTypography>
        <Typography>
          {data.KENDARAAN} {data.JENIS_KENDARAAN}{" "}
          {data.KEPEMILIKAN_KENDARAAN ? `(${data.KEPEMILIKAN_KENDARAAN})` : ""}
        </Typography>
        <SubTitleTypography>Alamat Sesuai KTP</SubTitleTypography>
        <Typography>{data.ALAMAT_DALAM_KOTA}</Typography>
        <SubTitleTypography>Alamat Domisili Saat Ini</SubTitleTypography>
        <Typography>{data.ALAMAT_LUAR_KOTA}</Typography>
        <SubTitleTypography>
          Kepemilikan Alamat Domisili Saat Ini
        </SubTitleTypography>
        <Typography>{data.KEPEMILIKAN_ALAMAT_LUAR_KOTA}</Typography>
        <SubTitleTypography>No. Handphone</SubTitleTypography>
        <Typography>{data.NOMOR_HANDPHONE}</Typography>
        <SubTitleTypography>Akun Sosial Media</SubTitleTypography>
        <IconTypography>
          <FacebookIcon sx={{ verticalAlign: "middle" }} /> :{data.FACEBOOK}
        </IconTypography>
        <IconTypography>
          <InstagramIcon sx={{ verticalAlign: "middle" }} /> :{data.INSTAGRAM}
        </IconTypography>
        <IconTypography>
          <YouTubeIcon sx={{ verticalAlign: "middle" }} /> :{data.YOUTUBE}
        </IconTypography>
        <IconTypography>
          <TwitterIcon sx={{ verticalAlign: "middle" }} /> :{data.TWITTER}
        </IconTypography>
        <IconTypography>
          <LinkedInIcon sx={{ verticalAlign: "middle" }} /> :{data.LINKEDIN}
        </IconTypography>
        <IconTypography>
          <EmailIcon sx={{ verticalAlign: "middle" }} /> :{data.EMAIL}
        </IconTypography>
      </Grid>
    </BaseGrid>
  );
}
